import { Installation } from "../Installation";

export class InstallationCaosUserSyncConfiguration extends Installation {
    syncToInstallationName: string;
    lastSynchronization: Date;
    isMaster: boolean;
    syncTime: string;

    public parse(obj: any) {
        super.parse(obj);
        if (obj.SyncToInstallationName) this.syncToInstallationName = obj.SyncToInstallationName;
        if (obj.LastSynchronization) this.lastSynchronization = obj.LastSynchronization;
        if (obj.IsMaster != null && obj.IsMaster != undefined) this.isMaster = obj.IsMaster;
        if (obj.SyncTime) this.syncTime = obj.SyncTime;
    }
}
